import FCCancellationPolicyTimeline from './FCCancellationPolicyTimeline';
//styles
import * as S from './CancelPolicyComponent.styles';
import FCTimelineDetails from './FCTimelineDetails/FCTimelineDetails';

export default function CancelPolicyComponent({
  title,
  cancellationPolicyTimeline,
  cancellationPolicy,
  cancellationTimeline,
  stylesTop = {},
  stylesBaseColumnWrap = {},
  isGreyDotBlocked = false,
  titleStyles = {},
}) {
  return (
    <>
      <S.Cancel_policy_wrap styles={stylesTop}>
        <S.BaseColumnWrap styles={stylesBaseColumnWrap}>
          <S.Header_p titleStyles={titleStyles}>{title}</S.Header_p>
        </S.BaseColumnWrap>
        <div className="appendTop15">
          {cancellationPolicyTimeline ? (
            <FCCancellationPolicyTimeline cancellationPolicyTimeline={cancellationPolicyTimeline} />
          ) : (
            <FCTimelineDetails cancellationTimeline={cancellationTimeline} />
          )}
        </div>

        <S.CancellationList>
          {cancellationPolicy?.cancelRules?.length &&
            cancellationPolicy?.cancelRules.map(rule => (
              <>
                {!rule.descText ? (
                  <li key={rule.text}>
                    {!isGreyDotBlocked && <S.GreyDot />}
                    <S.DescriptionText dangerouslySetInnerHTML={{__html: rule.text}} />
                  </li>
                ) : (
                  <S.RuleWithDescription>
                    <S.RuleWithText dangerouslySetInnerHTML={{__html: rule.text}} />
                    <S.CancellationPolicyTable>
                      <p className="cncpolicyTbl__head">
                        <span className="cncpolicyTbl__col">DATE</span>
                        <span className="cncpolicyTbl__col">FEE</span>
                      </p>
                      {rule?.descText?.length &&
                        rule.descText.map(item => (
                          <p className="cncpolicyTbl__row">
                            <span
                              className="cncpolicyTbl__col"
                              dangerouslySetInnerHTML={{__html: item.dateText}}
                            />
                            <span className="cncpolicyTbl__col">{item.feeText}</span>
                          </p>
                        ))}
                    </S.CancellationPolicyTable>
                  </S.RuleWithDescription>
                )}
              </>
            ))}
        </S.CancellationList>
      </S.Cancel_policy_wrap>
    </>
  );
}
